import React from 'react';

const renderLandingMessage = () => {
    return <span>
        Welcome to <span className="centralOnly">Central Bank</span><span className="jeffersonOnly">Jefferson</span><span className="bankCentralOnly">Bank Central</span>!
    </span>;
};

const renderCopyrightMessage = () => {
    const date = new Date();
    const year = date.getFullYear();
    return <span>
        Copyright © {year} <span className="centralOnly">Central Bank</span><span className="jeffersonOnly">Jefferson Bank, a division of The Central Trust Bank.</span><span className="bankCentralOnly">Bank Central, a division of The Central Trust Bank.</span> All rights reserved.
    </span>;
};

const renderCustomerMessage = () => {
    return <span>
        My relationship with <span className="centralOnly">Central Bank</span><span className="jeffersonOnly">Jefferson</span><span className="bankCentralOnly">Bank Central</span> is through:
    </span>;
};

const renderCustomerNoneMessage = () => {
    return <span>
        I am new to  <span className="centralOnly">Central Bank</span><span className="jeffersonOnly">Jefferson</span><span className="bankCentralOnly">Bank Central</span>.
    </span>;
};

const renderReferenceMessage = () => {
    return <span>
        I chose <span className="centralOnly">Central Bank</span><span className="jeffersonOnly">Jefferson</span><span className="bankCentralOnly">Bank Central</span> because:
    </span>;
};

const renderBorrowPathMessage = () => {
    return <span>
        I want to learn more about the <span className="centralOnly">Central Bank</span><span className="jeffersonOnly">Jefferson</span><span className="bankCentralOnly">Bank Central</span> experience.
    </span>;
};

export default {
    "copyright": renderCopyrightMessage(),
    "isCustomer": renderCustomerMessage(),
    "referenceType": renderReferenceMessage(),
    "wantsToDoBorrowPath": renderBorrowPathMessage(),
};
